import { AppData, Colors, Lightning } from '@lightningjs/sdk';
import { getFontFaceFromStyle } from 'support/textUtils';
import { SelectItemContext } from 'types/events';
import Tile, { TileTemplateSpec } from './Tile';
import { constants } from 'aliases';
import TextLabel from '../TextLabel';

export interface SeeAllTileTemplateSpec extends TileTemplateSpec {
  actionArgs?: unknown;

  Background: Lightning.Component;
  Label: typeof TextLabel;
}

const TILE_RADIUS = 10;
const LABEL_FONT_SIZE = 28;
export default class SeeAllTile extends Tile<SeeAllTileTemplateSpec> {
  private _labelText = '';

  protected _Background = (this as SeeAllTile).getByRef('Background')!;
  protected _Label = (this as SeeAllTile).getByRef('Label')!;

  protected override _action: SelectItemContext['action'] = 'navigation';
  protected _actionArgs: SeeAllTileTemplateSpec['actionArgs'] = undefined;

  override get title() {
    return this._labelText;
  }

  set labelText(labelText: string) {
    this._labelText = labelText;
    this._Label.patch({ text: { text: labelText } });
  }

  override set action(action: SelectItemContext['action']) {
    this._action = action;
  }

  override get action(): SelectItemContext['action'] {
    return this._action;
  }

  set actionArgs(actionArgs: SeeAllTileTemplateSpec['actionArgs']) {
    this._actionArgs = actionArgs;
  }

  static override _template(): Lightning.Component.Template<SeeAllTileTemplateSpec> {
    return {
      ...super._template(),
      Background: {
        rect: true,
        w: w => w,
        h: h => h,
        colorLeft: Colors('seeAllTileGradientStart').get(),
        colorRight: Colors('seeAllTileGradientEnd').get(),
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: TILE_RADIUS,
        },
      },
      Label: {
        type: TextLabel,
        mount: 0.5,
        x: w => w / 2,
        y: h => h / 2,
        text: {
          text: '',
          fontSize: LABEL_FONT_SIZE,
          fontFace: getFontFaceFromStyle('regular'),
          textColor: Colors('text').get(),
          textAlign: 'center',
        },
      },
    };
  }

  override _setup() {
    super._setup();

    const resize = {
      w: this.w + constants.ui.highlightSizeOffset,
      h: this.h + constants.ui.highlightSizeOffset,
    };

    this.hoverHighlightEnabled = true;
    this._HoverHighlight.patch({ ...resize });
    this._Placeholder.patch({ ...resize });
    this._VisibilityIndicator.patch({ ...resize });
  }

  override _handleClick() {
    if (!AppData?.device.canMouseClick()) return;
    if (!this.hovered) return;

    this.onTileSelected();
  }

  override _handleHover(target: any) {
    super._handleHover(target);
    return false;
  }

  override onTileSelected() {
    this.fireAncestors('$onSeeAllSelected', {
      action: this._action,
      actionArgs: this._actionArgs,
      parentContext: this.parentContext,
    });
  }
}
